import { useEffect, useRef } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';

const PcModelStatTip = ({
  type,
  parameter,
  isTooltipOpen,
  handleCloseModal,
}) => {
  const useOutsideClick = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          handleCloseModal();
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  const data = {
    over: {
      icon: '/icons/icon-exceeds.svg',
      text: `The ${parameter} on this PC configuration exceeds your needs, but future proofing is always a great idea!`,
    },
    under: {
      icon: '/icons/icon-falls-short.svg',
      text: `The ${parameter} on this PC configuration doesn't meet your needs. Consider an upgrade!`,
    },
    meets: {
      icon: '/icons/icon-meets.svg',
      text: `We’re confident this configuration meets the ${parameter} requirements you outlined in the quiz`,
    },
  };

  return (
    <>
      {type && parameter && isTooltipOpen === true ? (
        <>
          <div className="tip-container" ref={wrapperRef}>
            <div className="tip-icon">
              <button type="button" onClick={handleCloseModal}>
                <Image draggable={false} src={data[type].icon} alt="Tip" width={80} height={80} />
              </button>
              <div className="tip-text">{data[type].text}</div>
            </div>
          </div>
          <div className="arrow-top" />
        </>
      ) : null}
      <style global jsx>
        {`
          .contents a {
            color: #fd0300;
          }
        `}
      </style>
      <style jsx>
        {`
          .tip-container {
            position: absolute;
            top: 32px;
            right: -20px;
            width: 208px;
            border-radius: 2px;
            background-color: #242424;
            z-index: 10;
            padding: 8px;
          }
          .tip-icon {
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-start;
          }

          .tip-icon button {
            border: none;
            background: none;
            cursor: pointer;
            margin: 0;
            padding: 0;
          }
          .tip-text {
            margin-left: 8px;
            font-family: 'Roboto-Medium';
            font-size: 13px;
            line-height: 20px;
            color: #ffffff;
          }
          .arrow-top {
            position: relative;
            top: -12px;
            left: 0px;
            width: 0px;
            height: 0px;
            border: 10px solid red;
            border-color: transparent transparent #242424 transparent;
            z-index: 30;
          }
        `}
      </style>
    </>
  );
};

PcModelStatTip.propTypes = {
  type: PropTypes.oneOf(['under', 'over', 'meets']).isRequired,
  parameter: PropTypes.string.isRequired,
  isTooltipOpen: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

export default PcModelStatTip;
